import React, { ReactNode } from "react";
import { MDXProvider } from "@mdx-js/react";
import LearningPageParent from "~/components/LearningPageParent";
import LearningPageStudent from "~/components/LearningPageStudent";
import RelatedGames from "~/components/LearningPageRelatedActivities";
import GameEmbed from "~/components/GameEmbed";

const components = {
  Student: LearningPageStudent,
  Parent: LearningPageParent,
  RelatedActivities: RelatedGames,
  GameEmbed,
};

type MDXProviderWrapperProps = {
  readonly children: ReactNode;
};

export default function MDXProviderWrapper({
  children,
}: MDXProviderWrapperProps) {
  return <MDXProvider components={components}>{children}</MDXProvider>;
}
